 // const URI="http://3.7.220.235:8001"; //Dev URL
 const URI="https://uat-nsws-mnstrportal.investindia.gov.in/gateway"; //UAT URL
// const URI="https://www.ppe-nsws-mnsportal.maadhyam.gov.in"; //PPE URL
//const FileDownload="http://192.168.50.99:8888";
 // const URI="http://192.168.50.208:8888"; //SIT URL
// const URI = "https://qa-nsws-mnstrportal.investindia.gov.in"; //SIT URL
export default URI;